import $ from 'jquery';
class Watch {
    init(that) {
        // Config Page name (for Styling and etc.)
        const [CT] = that.context;
        CT.set_classing({
            route: that.pageName.toLowerCase(),
        });
        // show APP on Document Ready - !!!!!! do it better
        // $('.APP').hide()
        // $(document).ready(function () {
        // $('.APP').show()
        // })
        //// Animations (Auto Init)
        // -- anim_switchup
        let animElements = $('[id^=anim_]')
        animElements.map((i, element) => {
            this._animator(that, $(element).attr('id').substr(0, $(element).attr('id').search('-')), $(element).attr('id').substr($(element).attr('id').search('-') + 1), $(element).data())
        })
        //// Components options
        // -- TabScreen
        // CT.options.COMPONENTS.TabScreen && $('.APP .TabScreen .tabs .tab').css('color', CT.options.DEFINES[CT.options.COMPONENTS.TabScreen.ACTIVE_TAB_COLOR || '#000000'])
        // that.state.J_Components.TabScreen && $('.APP .TabScreen .tabs .tab').css('color', that.state.J_Components.TabScreen._options.ACTIVE_TAB_COLOR)
        // -- Image
        // that.state.J_Components.Image && $(`.APP .IC`).css('border-radius', that.state.J_Components.Image._options.BORDER_RADIUS)
        // Object.keys(that.state.J_Components).some(function (k) {
        // if (~k.indexOf("Image_") == -1) {
        // $(`.APP .IC[data-state='${k.substr(k.search('_') + 1, k.length)}']`).css('border-radius', that.state.J_Components[k]._options.BORDER_RADIUS)
        // }
        // })
        //// Component Events
    }
    punksScrollLoad(that) {
        let scrollBlock = false;
        $('.APP .SCROLLVIEW').on('scroll', function () {
            if (parseInt($(this).scrollTop()) >= parseInt($('.APP .Punkontainer').height() - 600)) {
                add50ToPunksLenght()
                scrollBlock = false
            }
        });
        const add50ToPunksLenght = () => {
            if (!scrollBlock) {
                that.setState({
                    interf: {
                        ...that.state.interf,
                        lengthOfShowingPunks: that.state.interf.lengthOfShowingPunks + 50
                    }
                })
                scrollBlock = true
            }
        }
    }
}
export default new Watch();